import { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import Wrapper from "../../../components/UI/Wrapper";
import SearchIcon from "@mui/icons-material/Search";
import './ExpenseDetail.css'
import Bills from '../../../Icons/Bills.png'
import filterIcon from "../../../Icons/filterIcon.png";
import QuotationMarks from '../../../Icons/QuotationMarks.png'
import axios from "axios";
import { CheckBox } from "@mui/icons-material";
import { MdDelete } from "react-icons/md";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const ExpenseDetail = ({ relocation_id }) => {
  const Relocation_ID = relocation_id || 0; // Default to 0 if relocation_id is not provided
  const [expenseDetail, setExpenseDetail] = useState([]);



  const [formData, setFormData] = useState({
    expense_detail_id: null,
    relocation_id: relocation_id || null,
    bill_no: "",
    location: "",
    expense_date: "",
    expense_type: 1,
    expense_description: null,
    vendor_id: null,
    rate: 0,
    quantity: 0,
    sale_amount: 0,
    payment_mode: "",
    payment_made_by: "",
    expense_amount: 0,
    remarks: "",
    attachment: "",
    added_date: "",
    added_by: "",
    payment_status: 1,
    approved_by: "",
    expense_category: null,
    file_status: "",
  });

  // Single handleChange function to update form data


  const [expenseDetailResponse, setExpenseDetailResponse] = useState([]);
  const [relocationDetailResponse, setRelocationDetailResponse] = useState([]);
  const baseAPI = process.env.REACT_APP_API_URL;
  const baseImageURL = process.env.REACT_APP_IMAGE_URL;
  const storedToken = JSON.parse(localStorage.getItem("token"));
  const [expenseCategory, setExpenseCategory] = useState([]);
  const [expenseDescription, setExpenseDescription] = useState([]);
  const [expenseType, setExpenseType] = useState([]);
  const [locationDetail, setLocationDetail] = useState([]);
  const [paymentMode, setPaymentMode] = useState([]);
  const [paymentMadeBy, setPaymentMadeBy] = useState([]);
  const [vendorDetail, setVendorDetail] = useState([]);
  const [pettyCashMaster, setPettyCashMaster] = useState([]);
  const [amountDetailForLead, setAmountDetailForLead] = useState([]);


  const handleChange = (e) => {
    const { name, value } = e.target;

    let updatedForm = {
      ...formData,
      [name]: value,
    };

    // Update expense_category when expense_description changes
    if (name === "expense_description") {
      const selectedExpense = expenseDescription.find(
        (exp) => exp.expense_description_id.toString() === value
      );
      if (selectedExpense) {
        updatedForm.expense_category = selectedExpense.expense_category_id || "0";
      }
    }

    // Recalculate expense_amount if rate or quantity changes
    if (name === "rate" || name === "quantity") {
      const rate = parseFloat(name === "rate" ? value : formData.rate) || 0;
      const quantity = parseFloat(name === "quantity" ? value : formData.quantity) || 0;
      updatedForm.expense_amount = (rate * quantity).toFixed(2);
    }

    setFormData(updatedForm);
  };


  const resetFormData = () => {

    setFormData({
      expense_detail_id: null,
      relocation_id: relocation_id || null,
      bill_no: "",
      location: "",
      expense_date: "",
      expense_type: 1,
      expense_description: null,
      vendor_id: null,
      rate: 0,
      quantity: 0,
      sale_amount: 0,
      payment_mode: "",
      payment_made_by: "",
      expense_amount: 0,
      remarks: "",
      attachment: "",
      added_date: "",
      added_by: "",
      payment_status: 1,
      approved_by: "",
      expense_category: null,
      file_status: "",
    });
  };



  const handledelete = async (e, expense_detail_id) => {
    e.preventDefault();

    const confirmDelete = window.confirm("Are you sure you want to delete this expense?");
    if (!confirmDelete) return;

    try {

      const headers = {
        Authorization: `Bearer ${storedToken}`, // Replace with your token logic
        "Content-Type": "application/json",
      };

      const deleteData = {
        expense_category_id: expense_detail_id,
      }

      const response = await axios.post(`${baseAPI}UserPost/DeleteExpense`, deleteData, { headers });

      if (response.status === 200) {

        toast.success("Expense deleted Successfully!!", {
          position: "top-right",
          autoClose: 2000, // Auto close after 3 seconds
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });

        setExpenseDetailResponse((prev) => prev.filter(exp => exp.expense_detail_id !== expense_detail_id));
        // fetchData(); // Refresh the data after saving

      } else {
        console.error("Unexpected response:", response);
        alert("Error deleting expense!");
      }
    } catch (error) {
      console.error("Error deleting expense:", error.response ? error.response.data : error.message);
      alert("Error deleting expense!");
    }
  };

  const navigate = useNavigate();
  const handleClick = (expense_detail_id) => {
    const url = `/UpdateExpenseDetails?expense_detail_id=${expense_detail_id}&relocation_id=${Relocation_ID}`;
    window.open(url, '_blank'); // '_blank' opens in a new tab
  };


  const [showForm, setShowForm] = useState(false);

  const handleAddClick = () => {
    // setShowForm(true);
    // fetchExpenseMasterData();


    const url = `/UpdateExpenseDetails?expense_detail_id=&relocation_id=${Relocation_ID}`;
    window.open(url, '_blank'); // '_blank' opens in a new tab

  };

  const fetchExpenseMasterData = async () => {
    try {
      const headers = {
        Authorization: `Bearer ${storedToken}`,
        "Content-Type": "application/json",
      };

      const [
        expenseDescriptionRes,
        locationDetailRes,
        paymentModeRes,
        vendorDetailRes,
        pettyCashMasterRes,
      ] = await Promise.all([
        axios.get(`${baseAPI}adminGet/GetExpenseDescriptions?expense_type=1&expense_category=0`, { headers }),
        axios.get(`${baseAPI}adminGet/GetLocations`, { headers }),
        axios.get(`${baseAPI}adminGet/GetPaymentMode`, { headers }),
        axios.get(`${baseAPI}adminGet/GETSupplier?SupplierID=0`, { headers }),
        axios.get(`${baseAPI}adminGet/GetPettyCashMaster`, { headers }),
      ]);
      setExpenseDescription(expenseDescriptionRes.data.data);
      setLocationDetail(locationDetailRes.data.data);
      setPaymentMode(paymentModeRes.data.data);
      setVendorDetail(vendorDetailRes.data.data);
      setPettyCashMaster(pettyCashMasterRes.data.data);
    } catch (error) {
      console.error("Error fetching master data:", error);
    }
  };


  const handleSave = async (e) => {
    e.preventDefault();
    try {

      const headers = {
        Authorization: `Bearer ${storedToken}`, // Replace with your token logic
        "Content-Type": "application/json",
      };

      const response = await axios.post(`${baseAPI}UserPost/InsertUpdateCmpExpenseDetail`, formData, { headers });

      if (response.status === 200) {
        alert("Expense saved successfully!");
        toast.success("Expense saved successfully!");
        resetFormData(); // Reset the form data after saving{
        setShowForm(false);
        fetchData(); // Refresh the data after saving

      } else {
        console.error("Unexpected response:", response);
        alert("Error saving expense!");
      }
    } catch (error) {
      console.error("Error saving expense:", error.response ? error.response.data : error.message);
      alert("Error saving expense!");
    }
  };


  const fetchData = async () => {
    try {
      const headers = {
        Authorization: `Bearer ${storedToken}`, // Replace with your token logic
        "Content-Type": "application/json",
      };
      const relocationDetailRes = await axios.get(`${baseAPI}userGet/GetRelocationdetailForEstimate?relocation_id=${Relocation_ID}`, { headers });
      setRelocationDetailResponse(relocationDetailRes.data.data[0]);

      const expenseDetailRes = await axios.get(`${baseAPI}userGet/GetExpenseDetails?expense_detail_id=0&relocation_id=${Relocation_ID}`, { headers });
      setExpenseDetailResponse(expenseDetailRes.data.data);

      const AmountDetailForLeadRes = await axios.get(`${baseAPI}userGet/GetAmountDetailForLead?relocation_id=${Relocation_ID}`, { headers });
      setAmountDetailForLead(AmountDetailForLeadRes.data.data[0]);


    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }


  useEffect(() => {
    fetchData();
  }, []);


  function formatDateWithTime(dateString) {

    const dateObj = new Date(dateString);
    if (!dateString) return "N/A";
    if (isNaN(dateObj)) return "Invalid date";


    const formatted = dateObj.toLocaleString('en-US', {
      month: 'short',
      day: '2-digit',
      year: 'numeric',
    }).replace(',', '');

    return formatted.replace(' AM', 'AM').replace(' PM', 'PM');
  }



  return (
    <div>
      <div
        style={{ overflowX: "hidden" }}
        className="container-fluid container-viewLeadDetails py-0 px-1"
      >
        <Wrapper className="LeadDetails">
          <ToastContainer />
          <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "20px" }}>
            <button className="filterButton">
              <img src={filterIcon} />
              {" "}FILTER
            </button>
            <div style={{ display: "flex", justifyContent: 'space-between' }} >
              <button
                className="btn btn-primary"
                onClick={handleAddClick}
                style={{
                  margin: "0",
                  backgroundColor: "white",
                  color: "#6A6A6A",
                  borderColor: "#C0C6CC",
                  whiteSpace: "nowrap",
                  width: "auto",
                }}
              >
                + Add Expense
              </button>
              <div style={{
                backgroundColor: "white", color: "#00B507", border: "2px solid #00B507", whiteSpace: "nowrap", width: "auto", borderRadius: '8px', display: 'flex',
                justifyContent: 'center', alignItems: 'center', borderRadius: '8px', marginLeft: '10px'
              }}>
                <img className="px-2" src={QuotationMarks} />
                <h4 className="px-2" style={{ fontSize: '15px', margin: '0px' }}>INVOICE - ₹{amountDetailForLead.invoice_amount}</h4>
              </div>
              <div style={{ border: '2px solid #C0C6CC', display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: '8px', marginLeft: '10px', backgroundColor: '#EEE9FF', minWidth: "100px" }}>
                <h4 className="px-2" style={{ color: '#6A6A6A', fontSize: '14px', fontWeight: '600', margin: '0px' }}>Sales :
                  <span style={{ color: '#5B489D', fontSize: '14px' }}> ₹{amountDetailForLead.sales}</span>
                </h4>
              </div>
              <div style={{ border: '2px solid #C0C6CC', display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: '8px', marginLeft: '10px', backgroundColor: '#FFDADA', minWidth: "100px" }}>
                <h4 className="px-2" style={{ color: '#6A6A6A', fontSize: '14px', fontWeight: '600', margin: '0px' }}>C.O.G.S :
                  <span style={{ color: '#5B489D', fontSize: '14px' }}> ₹{amountDetailForLead.COGS}</span>
                </h4>
              </div>
              <div style={{ border: '2px solid #C0C6CC', display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: '8px', marginLeft: '10px', backgroundColor: '#D8FFD9', minWidth: "100px" }}>
                <h4 className="px-2" style={{ color: '#6A6A6A', fontSize: '14px', fontWeight: '600', margin: '0px' }}>G. P. :
                  <span style={{ color: '#5B489D', fontSize: '14px' }}> ₹{amountDetailForLead.GP}</span>
                </h4>
              </div>
            </div>
          </div>
          <>
            <hr />
            {showForm && (
              <div class="container-1">
                <div class="row">
                  <div class="col-12">
                    <h2 class="text-left" style={{ fontSize: "18px", padding: "9px 0 0 16px" }}>Add Expense</h2>
                  </div>
                </div>

                <div class="row expense-rowms" >
                  <div class="col-md-3">
                    <label className="label-expenseMs">Date of Expense</label>
                    <input type="date" class="form-control form-control-expencsems" name="expense_date" onChange={handleChange} value={formData.expense_date} max={new Date().toISOString().split("T")[0]} />
                  </div>
                  <div class="col-md-6">
                    <label className="label-expenseMs">Vendor (if not registered , first add a vendor)</label>
                    <select class="form-control form-control-expencsems" name="vendor_id" onChange={handleChange} value={formData.vendor_id}>
                      <option>Select</option>
                      {vendorDetail.map((exp) => (
                        <option key={exp.Vendor_Id} value={exp.Vendor_Id}>
                          {exp.VendorFirstName} {exp.VendorLastName}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div class="col-md-3">
                    <label className="label-expenseMs">Location</label>
                    <select class="form-control form-control-expencsems" name="location" onChange={handleChange} value={formData.location} >
                      <option>Select</option>
                      {locationDetail.map((location) => (
                        <option key={location.location_id} value={location.location_id}>
                          {location.location}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div class="row expense-rowms" >
                  <div class="col-md-5">
                    <label className="label-expenseMs">Expense Description</label>
                    <select class="form-control form-control-expencsems" name="expense_description" onChange={handleChange} value={formData.expense_description}>
                      <option value="0" >Select</option>
                      {expenseDescription.map((exp) => (
                        <option key={exp.expense_description_id} value={exp.expense_description_id}>
                          {exp.description}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div class="col-md-2">
                    <label className="label-expenseMs">Rate</label>
                    <input type="text" class="form-control form-control-expencsems" placeholder="Enter" name="rate" onChange={handleChange} value={formData.rate} />
                  </div>
                  <div class="col-md-2">
                    <label className="label-expenseMs">Quantity</label>
                    <input type="text" class="form-control form-control-expencsems" placeholder="Enter" name="quantity" onChange={handleChange} value={formData.quantity} />
                  </div>
                  <div class="col-md-3">
                    <label className="label-expenseMs">Expense Amount</label>
                    <input type="text" class="form-control form-control-expencsems" placeholder="Enter" name="expense_amount" onChange={handleChange} value={formData.expense_amount} />
                  </div>
                </div>
                <div class="row expense-rowms" >
                  <div class="col-md-3">
                    <label className="label-expenseMs">Payment Mode</label>
                    <select class="form-control form-control-expencsems" name="payment_mode" onChange={handleChange} value={formData.payment_mode}  >
                      <option>Select</option>
                      {paymentMode.map((exp) => (
                        <option key={exp.payment_mode_id} value={exp.payment_mode_id}>
                          {exp.payment_mode}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div class="col-md-3">
                    <label className="label-expenseMs">Payment Made By</label>
                    <select class="form-control form-control-expencsems" name="payment_made_by" onChange={handleChange} value={formData.payment_made_by}
                      disabled={formData.payment_mode !== "2"}
                    >
                      <option value="" >Select</option>
                      {pettyCashMaster.map((exp) => (
                        <option key={exp.employee_id} value={exp.employee_id}>
                          {exp.Name}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div class="col-md-3">
                    <label className="label-expenseMs">Receipt No.</label>
                    <input type="text" class="form-control form-control-expencsems" placeholder="Enter" name="bill_no" onChange={handleChange} value={formData.bill_no} />
                  </div>
                  <div class="col-md-3">
                    <label className="label-expenseMs">Choose Document</label>
                    <input type="file" class="form-control form-control-expencsems" name="attachment" />
                  </div>
                </div>
                <div class="row expense-rowms" >
                  <div class="col-md-12">
                    <label className="label-expenseMs">Remark (If Any)</label>
                    <input type="text" class="form-control form-control-expencsems" placeholder="Enter" name="remarks" onChange={handleChange} value={formData.remarks} />
                  </div>
                </div>
                <div class="row mt-4 text-left">
                  <div class="col-12" style={{ textAlign: 'end' }}>
                    <button type="button" className="btn" style={{ background: 'none', color: 'red' }} onClick={() => { setShowForm(false); resetFormData(); }}>Cancel</button>
                    <button type="submit" class="btn btn-primary" style={{ marginTop: "0px" }} onClick={handleSave}>Add +</button>
                  </div>
                </div>
              </div>
            )}
            <hr />
            <div className="viewLeadDetails-form">
              <table
                style={{
                  width: "100%",
                  color: "#6A6A6A",
                  borderRadius: "5px",
                }}
              >
                <tr className="viewLeadDetailsHeading">
                  <th
                    colSpan={4}
                    style={{
                      background: "#5B489D",
                      color: "white",
                      fontWeight: "bold",
                    }}
                  >
                    <span style={{ fontSize: "18px" }}>
                      {" "}
                      Details{" "}
                    </span>
                  </th>

                </tr>
                <tr className="viewLeadDetailsHeading">
                  <th>
                    <span>Customer Name</span>
                  </th>
                  <td>
                    <span> {relocationDetailResponse.first_name}
                    </span>
                  </td>
                  <th>
                    <span>Contact Number</span>
                  </th>
                  <td>
                    <span> {relocationDetailResponse.first_name} </span>
                  </td>
                </tr>

                <tr className="viewLeadDetailsHeading">
                  <th>
                    <span>No. of Pet</span>
                  </th>
                  <td>
                    <span> {relocationDetailResponse.Number_Of_Pets} </span>
                  </td>
                  <th>
                    <span>Pet Type</span>
                  </th>
                  <td>
                    <span> {relocationDetailResponse.pettype}</span>
                  </td>
                </tr>

                <tr className="viewLeadDetailsHeading">
                  <th>
                    <span>Pet Name & Breed</span>
                  </th>
                  <td>
                    <span>{relocationDetailResponse.petbreedtype}</span>
                  </td>
                  <th>
                    <span>Pet Dimensions & Crate </span>
                  </th>
                  <td>
                    <span> {relocationDetailResponse.crate_size} </span>
                  </td>
                </tr>

                <tr className="viewLeadDetailsHeading">
                  <th>
                    <span>Origin</span>
                  </th>
                  <td>
                    <span> {relocationDetailResponse.origin_city}</span>
                  </td>
                  <th>
                    <span>Destination</span>
                  </th>
                  <td>
                    <span>{relocationDetailResponse.destination_city}</span>
                  </td>
                </tr>
                <tr className="viewLeadDetailsHeading">
                  <th>
                    <span>Sales Co-ordinator</span>
                  </th>
                  <td>
                    <span>  {relocationDetailResponse.assigned_to_name} </span>
                  </td>
                  <th>
                    <span>Operation Co-ordinator</span>
                  </th>
                  <td>
                    <span> {relocationDetailResponse.Coordinator}  </span>
                  </td>
                </tr>
                <tr className="viewLeadDetailsHeading">
                  <th>
                    <span>Field Co-ordinator</span>
                  </th>
                  <td>
                    <span>  {relocationDetailResponse.Field_Ops}  </span>
                  </td>
                  <th>
                    <span></span>
                  </th>
                  <td>
                    <span></span>
                  </td>
                </tr>
              </table>
            </div>
            <div className="container-fluid px-0">
              <div className="expenseList" style={{ border: "1px solid grey", borderRadius: "16px" }}>
                <h2
                  className="Venderheading"
                  style={{
                    fontSize: "22px",
                    paddingLeft: "16px",
                    paddingTop: "7px",
                  }}
                >
                  Expense List
                </h2>
                <table style={{ width: "100%" }} className="table_expense">
                  <thead>
                    <tr className="expenseListHeading">
                      <th># </th>
                      <th colSpan={"2"}>Action </th>
                      <th>File </th>
                      <th>Date </th>
                      <th>Bill No. </th>
                      <th>Expense Description</th>
                      <th>Qty. </th>
                      <th>Vendor Name </th>
                      <th>Payment Mode </th>
                      <th>Payment Made by </th>
                      <th>Payment Status </th>
                      <th>Expense Group</th>
                      <th>Sale Amount</th>
                      <th>Expense Amount</th>
                      <th>Gross Profit </th>
                    </tr>
                  </thead>
                  <tbody>
                    {expenseDetailResponse !== null ? (
                      expenseDetailResponse.map((expense, index) => (
                        <tr key={index + 1}>
                          <td>{index + 1}</td>
                          <td  >
                            <button className="text-center" style={{
                              border: "none",
                              width: "37px",

                              height: "36px",

                              color: "#6a6a6a", border: "none",
                            }}
                              onClick={() => handleClick(expense.expense_detail_id)}
                            >
                              <img src={Bills} />
                            </button>
                          </td><td>
                            <button onClick={(e) => handledelete(e, expense.expense_detail_id)} className="text-center" style={{
                              border: "none",
                              width: "37px",
                              height: "36px",

                              color: "#6a6a6a", border: "none",
                            }} >
                              <MdDelete
                                className="icon"
                                style={{
                                  color: "red",
                                  height: "32px",
                                  width: "29px",
                                }} />
                            </button>
                          </td>
                          <td> <input style={{ padding: '7px', width: '33px', height: '16px' }} type="checkbox" /> </td>
                          <td>{formatDateWithTime(expense.expense_date)} </td>
                          <td>{expense.bill_no}</td>
                          <td>{expense.description}</td>
                          <td>{expense.quantity}</td>
                          <td>{expense.vendor_name}</td>
                          <td>{expense.payment_mode_name}</td>
                          <td>{expense.payment_made_by_name}</td>
                          <td>
                            <span style={{
                              backgroundColor: expense.payment_status_name === 'Paid' ? 'green' : 'orange',
                              color: 'white',
                              padding: '5px',
                              textAlign: 'center',
                              borderRadius: '15px',
                              minWidth: '70px',
                              display: 'inline-block',
                            }}
                            >
                              {expense.payment_status_name}
                            </span>
                          </td>
                          <td>{expense.expense_category_name}</td>
                          <td>{expense.sale_amount}</td>
                          <td>{expense.expense_amount}</td>
                          <td>{(expense.sale_amount || 0) - (expense.expense_amount || 0)}</td>
                        </tr>

                      ))
                    ) : (
                      <tr>
                        <td colSpan="15">No expenses available</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </>
        </Wrapper>

      </div>

    </div>
  )
}

export default ExpenseDetail;

